/*
 * Copyright (c) 2021. FINN Sp. z o.o.
 */

package pl.finn.forms.utils

val ATTACHMENTS = "Załączniki"

val FILE_EXTENSIONS = setOf(
  "7z", "avi", "CAdES", "css", "csv", "dgn", "doc",
  "docx", "dwf", "dwg", "dxf", "geotiff", "gif", "gml", "gz", "gzip", "html",
  "jp2", "jpeg", "jpg", "m4a", "mp3", "mp4", "mpeg", "mpeg4", "mpg", "odp", "ods",
  "odt", "ogg", "ogv", "ott", "PAdES", "pdf", "png", "ppt", "pptx", "rng", "rtf",
  "svg", "tar", "tif", "tiff", "tls", "txt", "wav", "XAdES", "xhtml", "xls",
  "xlsx", "xml", "XMLenc", "XMLsig", "xps", "xsd", "xsl", "xslt", "zip"
)

val ANNOTATIONS = mapOf(
  "PlikWyroznikaWzoru" to "Plik wyróżnika wzoru",
  "PlikSchematuWzoru" to "Plik schematu wzoru",
  "PlikWizualizacjiWzoru" to "Plik wizualizacji wzoru",
  "MaterialPowiazany" to "Materiał powiązany z przedmiotem wniosku",
  "TytulDokumentu" to "Tytuł dokumentu",
  "OpisRodzajuDokumentu" to "Opis rodzaju dokumentu",
  "NaglowekTresci" to "Nagłówek treści",
  "ZawartoscTresci" to "Zawartość treści",
)

fun getRandomString(): String {
  val allowedChars = ('a'..'z') + ('A'..'Z')
  return (1..8)
    .map { allowedChars.random() }
    .joinToString("")
}